import { authFetch } from '@/services/apiClient'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export interface FavoriteResult {
  favorite_id: number
  course_id: number
  created_date: string
  course: {
    course_id: number
    title: string
    slug: string
    thumbnail_url: string | null
    price: number
    original_price: number | null
    is_free: boolean
    category_id: number
    course_format: string
    status: string
  }
}

async function parseJson<T>(res: Response): Promise<ApiResponse<T>> {
  try {
    return await res.json()
  } catch {
    return { success: false, error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ' }
  }
}

export const getMyFavorites = async (): Promise<FavoriteResult[]> => {
  const res = await authFetch('/favorites')
  const json = await parseJson<FavoriteResult[]>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'โหลดรายการโปรดไม่สำเร็จ')
  return json.data
}

export const addFavorite = async (courseId: number): Promise<void> => {
  const res = await authFetch('/favorites', {
    method: 'POST',
    body: JSON.stringify({ course_id: courseId }),
  })
  const json = await parseJson<unknown>(res)
  if (!json.success) throw new Error(json.error || json.message || 'บันทึกรายการโปรดไม่สำเร็จ')
}

export const removeFavorite = async (courseId: number): Promise<void> => {
  const res = await authFetch(`/favorites/${courseId}`, { method: 'DELETE' })
  const json = await parseJson<unknown>(res)
  if (!json.success) throw new Error(json.error || json.message || 'เอาออกจากรายการโปรดไม่สำเร็จ')
}
